var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"version"},[_c('b',[_vm._v("Version")]),_vm._v(" "+_vm._s(_vm.version)+"\n  ")]),_vm._v(" "),_c('div',[_vm._v("Copyright © 2019 快鱼IT All rights reserved.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535a4ed2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KyFooter.vue
// module id = null
// module chunks = 